import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ed826cca"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-h-full tw-justify-between" }
const _hoisted_3 = { class: "tw-flex tw-justify-between tw-items-center wrapper" }
const _hoisted_4 = { class: "tw-text-[#211F58] tw-max-w-[138px] tw-text-[15px] tw-not-italic tw-font-[600] tw-leading-[130%] title" }
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "tw-px-[5px] tw-py-[3px] tw-bg-[#E4F1FF] tw-text-[#211F58] tw-rounded-[4px] tw-text-[11px] tw-font-medium tw-font-[Poppins]" }
const _hoisted_7 = ["id"]
const _hoisted_8 = { class: "tw-px-[5px] tw-py-[3px] tw-bg-[#E4F1FF] tw-text-[#211F58] tw-rounded-[4px] tw-text-[11px] tw-font-medium tw-font-[Poppins]" }
const _hoisted_9 = { class: "tw-flex align-items-end" }
const _hoisted_10 = { class: "detail-info" }
const _hoisted_11 = { class: "tw-text-[#211F58] tw-text-[13px] tw-font-[500]" }
const _hoisted_12 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_13 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[122px] tw-h-[19px]"
}
const _hoisted_14 = {
  key: 1,
  class: "tw-text-[#878787] tw-font-[400]"
}
const _hoisted_15 = { class: "tw-flex tw-justify-between tw-items-center" }
const _hoisted_16 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[122px] tw-h-[19px]"
}
const _hoisted_17 = {
  key: 1,
  class: "tw-text-[#878787] tw-font-[400]"
}
const _hoisted_18 = { class: "tw-text-[#211F58] tw-text-[13px] tw-font-[500] tw-flex tw-justify-between tw-items-center" }
const _hoisted_19 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[122px] tw-h-[19px]"
}
const _hoisted_20 = {
  key: 1,
  class: "tw-text-[#878787] tw-font-[400]"
}

import { getComponentUiText, getShortChecklistName } from "@/utils/utilities";
import {
  convertUTCTimeToLocalTime,
  getTimeFromNow,
} from "@/utils/dateTimeUtils";
import { checklistStatusId } from "@/utils/constants";
import { computed, onMounted, ref } from "vue";
import store from "@/store";
import { getDetailFromCheckListId } from "@/services/assessment";
import get from "lodash/get";
import { IChecklistInfoDetail } from "@/interfaces/assessments/IAssessmentDetails";
import { showErrorAPI } from "@/services/apiRoutes";
import { Checklist } from "@/services/apiRoutes/routes";


export default /*#__PURE__*/_defineComponent({
  __name: 'detailsCard',
  props: {
  isAssessmentDetail: {
    type: Boolean,
    required: false,
    default: false,
  },
  detail: {
    type: Object,
    required: false,
    default: () => ({}),
  },
},
  setup(__props) {

const props = __props;



onMounted(() => {
  getChecklistDetails();
});

const checklistLastUpdatedDate = ref("");

const checklistInfoDetail = computed<any>(() => {
  if (props.isAssessmentDetail) {
    const assessment = store.getters["Recommend/getChecklistDetailById"](
      props.detail.checklistId,
    );
    return {
      checklistCreatedDate: assessment.checklistDateCreated,
      checklistLastUpdatedDate: assessment.checklistDateEdited,
      checklistStatusId: assessment.checklistStatusId,
      checklistStatus: assessment.checklistStatus,
      checklistId: props.detail.checklistId,
    };
  } else {
    return store.getters["Assessment/getChecklistInforDetail"];
  }
});

const checklistTemplates = computed(() => {
  return store.getters["Recommend/getChecklistDetailById"](
    checklistInfoDetail.value?.checklistId,
  ).templates;
});

const currentChecklistId = computed(() => {
  return store.state.Assessment.currentChecklistId;
});

const getChecklistDetails = async () => {
  try {
    const res = await getDetailFromCheckListId(
      Number(props.detail.checklistId) || currentChecklistId.value,
    );
    const data = get(res, "data.data", {}) as IChecklistInfoDetail;
    checklistLastUpdatedDate.value = data.checklistLastUpdatedDate;
  } catch (error: any) {
    showErrorAPI(error, Checklist.getChecklistToItemMetric);
  }
};

const getLastUpdatedTimeFromNow = () => {
  if (!checklistLastUpdatedDate.value) return "-";
  return getTimeFromNow(checklistLastUpdatedDate.value);
};

const getCurrentTime = () => {
  if (!checklistInfoDetail.value.checklistCreatedDate) return "-";
  return convertUTCTimeToLocalTime(
    checklistInfoDetail.value.checklistCreatedDate,
    undefined,
    "HH:mm",
  );
};

const isShowFlagCard = computed(() => {
  return (
    checklistInfoDetail.value.checklistStatusId !== checklistStatusId.completed
  );
});

const isChecklistInfoDetailLoading = computed(() => {
  return Object.keys(checklistInfoDetail.value).length === 0;
});

return (_ctx: any,_cache: any) => {
  const _component_b_popover = _resolveComponent("b-popover")!

  return (_openBlock(), _createElementBlock("div", {
    id: `details-card-${__props.detail.checklistId}`,
    class: "tw-bg-[#FCFCFC] tw-min-w-[284px] tw-max-w-[284px] tw-h-[112px] tw-w-[100%] tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-border-solid tw-border-[#EFF0F1] tw-rounded-[6px]"
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
              "app-component-assessments-checklists-assessment-details-card-title-1",
            )), 1),
        (
            checklistTemplates.value &&
            checklistTemplates.value.length > 0 &&
            checklistTemplates.value[0]?.checklistTemplateName
          )
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: `checklist-template-name-detail-${__props.detail.checklistId}`,
              class: "default tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-center tw-text-[11px] tw-font-[500]"
            }, [
              _createTextVNode(_toDisplayString(checklistTemplates.value[0]?.checklistTemplateName) + " ", 1),
              _createVNode(_component_b_popover, {
                target: `checklist-template-name-detail-${__props.detail.checklistId}`,
                triggers: "hover",
                placement: "bottom",
                "custom-class": "custom-actions-popover",
                offset: 5,
                delay: {
              show: 0,
              hide: 100,
            },
                onShow: ($event: any) => (true)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(checklistTemplates.value[0]?.checklistTemplateName), 1)
                ]),
                _: 1
              }, 8, ["target"])
            ], 8, _hoisted_5))
          : (_openBlock(), _createElementBlock("div", {
              key: 1,
              id: `checklist-template-all-questions-detail-${__props.detail.checklistId}`,
              class: "default tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-center tw-text-[11px] tw-font-[500]"
            }, [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-component-assessments-checklists-assessment-template-tag-1",
            )) + " ", 1),
              _createVNode(_component_b_popover, {
                target: `checklist-template-all-questions-detail-${__props.detail.checklistId}`,
                triggers: "hover",
                placement: "bottom",
                "custom-class": "custom-actions-popover",
                offset: 5,
                delay: {
              show: 0,
              hide: 100,
            },
                onShow: ($event: any) => (true)
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessments-checklists-assessment-template-tag-1",
                )), 1)
                ]),
                _: 1
              }, 8, ["target"])
            ], 8, _hoisted_7))
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _withDirectives(_createElementVNode("div", _hoisted_12, [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessments-checklists-assessment-details-card-label-2",
                )) + " ", 1),
              (isChecklistInfoDetailLoading.value && !__props.isAssessmentDetail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13))
                : (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(getLastUpdatedTimeFromNow()), 1))
            ], 512), [
              [_vShow, isShowFlagCard.value]
            ]),
            _withDirectives(_createElementVNode("div", _hoisted_15, [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                  "app-component-assessments-checklists-assessment-details-card-label-3",
                )) + " ", 1),
              (isChecklistInfoDetailLoading.value && !__props.isAssessmentDetail)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(getLastUpdatedTimeFromNow()), 1))
            ], 512), [
              [_vShow, !isShowFlagCard.value]
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-checklists-assessment-details-card-label-1",
              )) + " ", 1),
            (isChecklistInfoDetailLoading.value && !__props.isAssessmentDetail)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19))
              : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(getCurrentTime()), 1))
          ])
        ])
      ])
    ])
  ], 8, _hoisted_1))
}
}

})